import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from '../../../constants/common';

const initialState = {
  accessDevices: [],
  pagination: {},
  accessDevice: {},
  errors: {},
  fetchingAccessDevices: FETCH_STATE.UNSENT,
  fetchingAccessDevice: FETCH_STATE.UNSENT,
  creatingAccessDevice: FETCH_STATE.UNSENT,
  deletingAccessDevice: FETCH_STATE.UNSENT,
  updatingAccessDevice: FETCH_STATE.UNSENT,
  assigningAccessDevice: FETCH_STATE.UNSENT,
  unassigningAccessDevice: FETCH_STATE.UNSENT,
  fetchingAddBroker: FETCH_STATE.UNSENT,
  fetchingRemoveBroker: FETCH_STATE.UNSENT,
};

const AccessDeviceReducer = createReducer(initialState)({
  // GET ACCESS DEVICE LIST
  [types.FETCH_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAccessDevices: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCESS_DEVICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAccessDevices: FETCH_STATE.DONE,
      accessDevices: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_ACCESS_DEVICE_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccessDevices: FETCH_STATE.ERROR,
    };
  },

  // GET ACCESS DEVICE BY ID
  [types.FETCH_ACCESS_DEVICE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      accessDevice: {},
      fetchingAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCESS_DEVICE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      accessDevice: payload.data,
      fetchingAccessDevice: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ACCESS_DEVICE_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccessDevice: FETCH_STATE.ERROR,
    };
  },

  // GET ACCESS DEVICE BY ID
  [types.FETCH_ACCESS_DEVICE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      accessDevice: {},
      fetchingAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCESS_DEVICE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      accessDevice: payload.data,
      fetchingAccessDevice: FETCH_STATE.DONE,
      updatingAccessDevice: FETCH_STATE.UNSENT,
      assigningAccessDevice: FETCH_STATE.UNSENT,
      unassigningAccessDevice: FETCH_STATE.UNSENT,
    };
  },
  [types.FETCH_ACCESS_DEVICE_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccessDevice: FETCH_STATE.ERROR,
    };
  },

  // CREATE ACCESS DEVICE
  [types.CREATE_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      creatingAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.CREATE_ACCESS_DEVICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      creatingAccessDevice: FETCH_STATE.DONE,
      accessDevice: payload.data,
    };
  },
  [types.CREATE_ACCESS_DEVICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      creatingAccessDevice: FETCH_STATE.ERROR,
      errors,
    };
  },

  // UPDATE ACCESS DEVICE
  [types.UPDATE_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      updatingAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.UPDATE_ACCESS_DEVICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      updatingAccessDevice: FETCH_STATE.DONE,
      accessDevice: payload.data,
    };
  },
  [types.UPDATE_ACCESS_DEVICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      updatingAccessDevice: FETCH_STATE.ERROR,
      assigningAccessDevice: FETCH_STATE.UNSENT,
      unassigningAccessDevice: FETCH_STATE.UNSENT,
      errors,
    };
  },

  // DELETE ACCESS DEVICE
  [types.DELETE_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      deletingAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.DELETE_ACCESS_DEVICE_SUCCESS]: (state) => {
    return {
      ...state,
      deletingAccessDevice: FETCH_STATE.DONE,
    };
  },
  [types.DELETE_ACCESS_DEVICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      deletingAccessDevice: FETCH_STATE.ERROR,
      errors,
    };
  },

  // ASSIGN ACCESS DEVICE
  [types.ASSIGN_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      assigningAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.ASSIGN_ACCESS_DEVICE_SUCCESS]: (state) => {
    return {
      ...state,
      assigningAccessDevice: FETCH_STATE.DONE,
      updatingAccessDevice: FETCH_STATE.UNSENT,
      unassigningAccessDevice: FETCH_STATE.UNSENT,
    };
  },
  [types.ASSIGN_ACCESS_DEVICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      assigningAccessDevice: FETCH_STATE.ERROR,
      errors,
    };
  },

  // UNASSIGN ACCESS DEVICE
  [types.UNASSIGN_ACCESS_DEVICE_REQUEST]: (state) => {
    return {
      ...state,
      unassigningAccessDevice: FETCH_STATE.LOADING,
    };
  },
  [types.UNASSIGN_ACCESS_DEVICE_SUCCESS]: (state) => {
    return {
      ...state,
      unassigningAccessDevice: FETCH_STATE.DONE,
      updatingAccessDevice: FETCH_STATE.UNSENT,
      assigningAccessDevice: FETCH_STATE.UNSENT,
    };
  },
  [types.UNASSIGN_ACCESS_DEVICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      unassigningAccessDevice: FETCH_STATE.ERROR,
      errors,
    };
  },

  // RESET ACCESS DEVICE STATE
  [types.RESET_ACCESS_DEVICE_STATE]: () => {
    return { ...initialState };
  },

  // RESET ACCESS DEVICE STATE
  [types.RESET_ACCESS_DEVICE]: (state) => {
    return {
      ...state,
      errors: {},
      accessDevice: null,
      creatingAccessDevice: FETCH_STATE.UNSENT,
      updatingAccessDevice: FETCH_STATE.UNSENT,
    };
  },

  // ADD BROKER
  [types.FETCH_ADD_BROKER_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddBroker: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ADD_BROKER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingAddBroker: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ADD_BROKER_FAILED]: (state, { payload }) => {
    return {
      ...state,
      fetchingAddBroker: FETCH_STATE.ERROR,
      errors: payload.errors,
    };
  },

  // REMOVE BROKER
  [types.FETCH_REMOVE_BROKER_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRemoveBroker: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_REMOVE_BROKER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingRemoveBroker: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_REMOVE_BROKER_FAILED]: (state) => {
    return {
      ...state,
      fetchingRemoveBroker: FETCH_STATE.ERROR,
    };
  },
});

export default AccessDeviceReducer;
